import {Field} from 'redux-form'
import styles from './ModifierOptionsField.css'
import ModifierInputWithoutValidation from 'pages/Library/Modifier/Detail/ModifierForm/ModifierInputWithoutValidation'

class ModifierOptionsField extends React.Component {
  render () {
    const {member} = this.props
    return (<div className='mk-grouped-input'>
      <div className='form-group col-sm-6'>
        <Field
          name={`${member}.name`}
          component={ModifierInputWithoutValidation}
          className='form-control'
          placeholder='Name'
        />
      </div>
      <div className='form-group col-sm-5'>
        <Field
          name={`${member}.price`}
          component={ModifierInputWithoutValidation}
          positiveNumberOnly
          maxFractionDigits={3}
          placeholder='Rp. 0'
          onChange={(e) => {
            if (isNaN(e.target.value)) {
              e.preventDefault()
            }
          }}
          className='form-control'
        />
      </div>
      <div className='col-sm-1' style={{marginTop: '7px'}}>
        <span className={`${styles['btn-delete']}`}
          onClick={this._onDelete}
          type='button'>
          <i className='fa fa-times-circle' />
        </span>
      </div>
    </div>)
  }

  _onDelete = () => {
    this.props.onDelete()
  }
}

ModifierOptionsField.propTypes = {
  member: React.PropTypes.object,
  onDelete: React.PropTypes.func
}

export default ModifierOptionsField



// WEBPACK FOOTER //
// ./app/pages/Library/Modifier/Detail/ModifierForm/ModifierOptionsModal/ModifierOptionsFieldArray/ModifierOptionsField/ModifierOptionsField.js